import { IconComponent } from 'models/icons';

/**
 * @deprecated This component has following errors from generation:
 *
 * **ERROR: assets/icons/multiple-objects.svg has a stroke color. Please outline strokes in figma before exporting it to svg.**
 *
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/multiple-objects.svg
 */
const IconMultipleObjects: IconComponent = ({
  size = 24,
  color = '#ffffff',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M6.95 17.052V23.5H23.5V6.948h-6.449"
      stroke="currentColor"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.05 6.948V.5H.5v16.552h6.451V6.948h10.1z"
      stroke="currentColor"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconMultipleObjects;
